import React, { Component } from "react"
import { Button, Icon, Affix, message, Row } from "antd"
import { observer, inject } from "mobx-react"
import { observable } from "mobx"
import closeIcon from "app/styles/images/sp/close.svg"
import UploadModal from "app/components/normal/BasicModal/UploadModal"
import MaterialModal from "app/components/normal/MaterialModal"
import cx from "classnames"
import getPathogenList from "app/utils/pathogenDispose"

@inject("pgdDataManageDetail", "auth")@observer
export default class extends Component {
  @observable confirmModalOpened = false
  @observable uploadModalOpened = false

  componentDidMount() {
    let { pgdDataManageDetail } = this.props
    
    const { auth } = this.props
    auth.getPushAuth()

    pgdDataManageDetail.loadFamilyInfo()
    .catch(
      err => {
        message.error(err.message)
      }
    )
  }

  saveTableData = () => {
    const { saveDatas, updateTableData } = this.props.pgdDataManageDetail

    return saveDatas()
    .then(result => {
      updateTableData()
      message.success("保存成功")
    }, error => {
      message.error(error.message)
      return Promise.reject(error)
    })
  }

  runProject = () => {
    const { selectedData } = this.props.pgdDataManageDetail
    this.saveTableData()
    .then(() => {
      if (selectedData.length > 0) {
        this.confirmModalOpened = true
      } else {
        message.error("还未勾选数据")
      }
    })
  }

  startRunTask = () => {
    this.props.pgdDataManageDetail.runTask()
    .then(() => {
      message.success("数据已开始运行")
      this.closeModal()
    }, error => {
      message.error(error.message)
    })
  }

  showUploadModal = () => {
    this.props.pgdDataManageDetail.getAppInfo()
  }

  dismissUploadModal = () => {
    this.props.pgdDataManageDetail.clearAppInfo()
  }

  closeModal = () => {
    this.confirmModalOpened = false
  }

  render() {
    const {
      familyInfo: { id, name, createTime },
      appInfo,
      saveReady,
      runReady
    } = this.props.pgdDataManageDetail
    const { auth: { pushAuth } } = this.props
    let saveBtnClass = cx({
      "green-btn save-btn": true,
      "disable": !saveReady
    })
    let runBtnClass = cx({
      "green-btn run-btn": true,
      "disable": !runReady
    })

    return (
      <Affix
        className="affix-head"
        target={() => document.getElementsByClassName("salt-pagelayout")[0]} offsetTop={0}
      >
        <div className="search-bar">
          <div className="left">
            <div>数据类型：PGD数据</div>
            <div>家系名称：{name}</div>
            <div>创建时间：{createTime}</div>
          </div>
          <div className="right">
            <Button
              className="add-btn"
              type="primary"
              size="default"
              onClick={this.showUploadModal}>
              <Icon type="plus" />添加数据
            </Button>
            <button
              disabled={saveReady ? "" : "disabled"}
              className={saveBtnClass}
              type="primary"
              size="default"
              onClick={this.saveTableData}>
              <Icon type="save" /> 保存
            </button>
            <button
              disabled={runReady ? "" : "disabled"}
              className={runBtnClass}
              type="primary"
              size="default"
              onClick={this.runProject}>
              <Icon type="caret-right" /> 开始运行
            </button>
          </div>
        </div>
        {
          this.confirmModalOpened && (
            <MaterialModal
              className="pgd-datamanage-confirm-modal"
              title="数据及引物确认"
              width={900}
              height={450}
              visible={true}
              footer={(
                <Row type="flex" justify="space-between" align="middle">
                  <button className="cancel-btn" onClick={this.closeModal}>有问题，返回修改</button>
                  <button className="ok-btn" onClick={this.startRunTask}>
                    <Icon type="caret-right" /> 确认无误，开始运行
                  </button>
                </Row>)}
            >
              <img
                className="pgx-modal-close"
                src={closeIcon}
                alt="关闭对话框"
                onClick={this.closeModal}
              />
              {this.renderDatas()}
            </MaterialModal>
          )
        }
        {appInfo &&
          <UploadModal
            visible
            verifyLimsPgdFamily={pushAuth.verifyLimsPgdFamily}
            info={appInfo}
            groupId={id}
            onCancel={this.dismissUploadModal}
            type="singleGroup"
          />
        }
      </Affix>
    )
  }

  renderDatas = () => {
    const { composedData } = this.props.pgdDataManageDetail
    return (
      <div className="content-data">
        {Object.keys(composedData).map(groupId =>
          <div key={groupId} className="confirm-data-group" >
            {composedData[groupId].map(this.renderDataItem)}
          </div>
        )}
      </div>
    )
  }

  renderDataItem = (sample) => {
    const pathogenList = getPathogenList(sample.relationName)

    return (
      <div className="confirm-data-item" key={sample.id}>
        <div className="item-relation-name">{sample.relationName}</div>
        <div className="item-pathogen">{pathogenList.get(sample.pathogen)}</div>
        <div className="item-filename">{sample.filename}</div>
        <div className="item-sample-name">{sample.sampleName}</div>
        <div className="item-primers">
          {sample.primers.map(primer => <span key={primer}>{primer}</span>)}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/pgd/data_manage_detail/containers/DataHeader.js